import React from 'react';
import { Link } from 'react-router-dom';

const LINKS = [
	{ to: '/journeys', label: 'Guided journeys' },
	{ to: '/festivals', label: 'Festivals' },
	{ to: '/trekking', label: 'Trekking' },
	{ to: '/visa', label: 'Visa guide' },
	{ to: '/guides', label: 'Travel Guide' },
];

/**
 * Points booking-oriented pages back to editorial content — helps users and crawlers
 * see Visit All Nepal as a travel guide, not only a checkout form.
 */
function ContentGuidesStrip({ compact = false }) {
	return (
		<aside
			className={`content-guides-strip${compact ? ' content-guides-strip--compact' : ''}`}
			aria-label="Free Nepal travel guides"
		>
			<div className="content-guides-strip__inner">
				<p className="content-guides-strip__lead">
					<strong>Free travel guides</strong>
					{compact
						? ' — plan your trip before you book.'
						: ' — Visit All Nepal publishes step-by-step trek planners, festival calendars, visa help, and destination guides. Explore before you reserve.'}
				</p>
				<nav className="content-guides-strip__links" aria-label="Travel guide sections">
					{LINKS.map(({ to, label }) => (
						<Link key={to} to={to}>{label}</Link>
					))}
				</nav>
			</div>
		</aside>
	);
}

export default ContentGuidesStrip;
